// Parse a backend ISO timestamp safely, treating naive strings (no Z / offset)
// as UTC. PostgreSQL's `timestamp without time zone` serializes without a TZ
// suffix, which the browser would otherwise interpret as local time and display
// UTC+8 hours off for Taipei viewers.
export function parseBackendDate(iso: string | null | undefined): Date | null {
    if (!iso) return null;
    const hasZone = /[zZ]|[+-]\d{2}:?\d{2}$/.test(iso);
    return new Date(hasZone ? iso : iso + 'Z');
}
